class cache {

    constructor() {
        this.client = [];
    };

    get(name, fns) {
        if (!name) return '';
        if (fns && typeof fns === 'function') {
            this._listen(name, fns);
        }
        else {
            return this[name];
        }
    }

    set(name, content) {
        if (!name) return '';
        this[name] = content;
        this._trigger(name, content);
    }

    setObject(options = {}, template = []) {
        if (typeof options != "object" || typeof template != "object") return false;
        
        template.forEach(element => {
            if (options.hasOwnProperty(element)) {
                this.set(element, options[element]);
            }
        });
    }


    _listen (key, fn) {
        if (!this.client[key]) {
            this.client[key] = [];
        }
        this.client[key].push(fn);
    }
    
    _trigger () {
        var key = Array.prototype.shift.call(arguments);
        var fns = this.client[key];
        if (!fns || fns.length === 0) {
            return false;
        }
        for (var i=0, fn; fn = fns[i++];) {
            fn.apply(this, arguments);
        }
    }
}

export default new cache()